export default __webpack_public_path__ + "static/media/15_bar graph 2.72ab9ebd.gif";